import { defineComponent as _defineComponent } from 'vue'
import { TranslateResult } from 'vue-i18n/types';

interface Props {
    tooltip?: boolean;
    tooltipText?: string | TranslateResult;
    disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadButton',
  props: {
    tooltip: { type: Boolean, default: false },
    tooltipText: { default: '' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any) {





return { __sfc: true, }
}

})